import React from 'react'
import { createPortal } from 'react-dom'

import { defaultDropAnimationSideEffects, DragOverlay } from '@dnd-kit/core'

import type { DropAnimation } from '@dnd-kit/core'
const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4',
      },
    },
  }),
}

export default function SortableOverlay({ children }) {
  return createPortal(
    <DragOverlay dropAnimation={dropAnimationConfig}>{children}</DragOverlay>,
    document.getElementById('root')
  )
}



// WEBPACK FOOTER //
// ./src/components/SortableList/SortableOverlay/index.tsx